import { AnimatePresence, motion } from "framer-motion";
import { ChevronDown, ChevronUp } from "lucide-react";
import React, { useState } from "react";

const FAQ = () => {
	const [openIndex, setOpenIndex] = useState(null);

	const faqs = [
		{
			question: "Who is Akua?",
			answer: "Akua is a trained AI therapist who is passionate about helping people in Ghana improve their well-being. Akua believes that therapy should be accessible and personalized, and she uses technology to make therapy more convenient and effective.",
		},
		{
			question: "How is my data handled?",
			answer: "Akua takes your privacy <strong>very seriously</strong>. All your conversations are securely end to end encrypted with external key management. What does that practically mean? Neither any developers nor any third party can see nor share your information. Even if our primary database were to be hacked, the hackers would not be able to read your data. Your data is not used for training any AI models.",
		},
		{
			question: "What are the benefits of therapy?",
			answer: "Research has shown that <a href='https://www.aft.org/news/12-rewarding-benefits-therapy' target='_blank' class='text-blue-500 hover:underline'>therapeutic talking</a> can significantly improve mental well-being. These practices help reduce stress and anxiety, increase self-awareness, process emotions more effectively, and provide clarity in decision-making.",
		},
		{
			question: "I have more questions!",
			answer: "Akua would love to help answer any questions you have! You can reach out to us at <a href='mailto:help@heyakua.com' class='text-blue-500 hover:underline'>help@heyakua.com</a>. She typically responds within 24 hours.",
		},
	];

	const toggleQuestion = (index) => {
		setOpenIndex(openIndex === index ? null : index);
	};

	return (
		<div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 p-4">
			<div className="w-full max-w-6xl backdrop-blur-lg rounded-3xl shadow-xl overflow-auto bg-white bg-opacity-90">
				<div className="py-10 md:py-12 px-6 md:px-10">
					<div className="flex justify-center items-center mb-10 md:mb-12">
						<h1 className="text-xl md:text-3xl font-light text-gray-800 text-center">
							Frequently Asked Questions
						</h1>
					</div>

					<div className="space-y-4">
						{faqs.map((faq, index) => (
							<div
								key={index}
								className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
								<button
									className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-all duration-300"
									onClick={() => toggleQuestion(index)}>
									<span className="text-gray-800 font-light">
										{faq.question}
									</span>
									{openIndex === index ? (
										<ChevronUp
											className="text-blue-400"
											size={20}
										/>
									) : (
										<ChevronDown
											className="text-blue-400"
											size={20}
										/>
									)}
								</button>
								<AnimatePresence>
									{openIndex === index && (
										<motion.div
											initial={{ height: 0, opacity: 0 }}
											animate={{
												height: "auto",
												opacity: 1,
											}}
											exit={{ height: 0, opacity: 0 }}
											transition={{
												duration: 0.3,
												ease: "easeInOut",
											}}
											className="overflow-hidden">
											<div className="px-6 py-4 bg-gray-50 border-t border-gray-100">
												<p
													className="text-gray-600 font-light"
													dangerouslySetInnerHTML={{
														__html: faq.answer,
													}}
												/>
											</div>
										</motion.div>
									)}
								</AnimatePresence>
							</div>
						))}
					</div>
				</div>
			</div>
		</div>
	);
};

export default FAQ;
